<div class="page-header">
  <h1 *ngIf="pageTitle">
    {{ pageTitle }}
    <small *ngIf="numberOfItem">({{ numberOfItem }})</small>
    <app-skeleton
      *ngIf="loading"
      color="#eee"
      width="30px"
      height="20px"
      margin="3px 0 -3px 3px"
    ></app-skeleton>
  </h1>

  <div class="page-header__inputs flex-wrap align-center justify-between">
    <form [formGroup]="searchForm" *ngIf="showSearch">
      <input
        [placeholder]="searchPlaceholder"
        type="text"
        formControlName="searchText"
      />
      <img src="assets/images/search.svg" alt="search" />
    </form>
    <ng-content></ng-content>
    <ng-content select="[addButton]"></ng-content>
  </div>
</div>
